
  var _styles = {
  "three-column-card": {
    "display": "flex",
    "flexDirection": "column",
    "width": "3.01333rem",
    "height": "5rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.16rem",
    "marginBottom": "0.16rem",
    "overflow": "hidden",
    "marginRight": "0.16rem"
  },
  "three-column-image-wrapper": {
    "position": "relative",
    "width": "3.01333rem",
    "height": "2.26667rem"
  },
  "three-column-image": {
    "width": "3.01333rem",
    "height": "2.26667rem"
  },
  "three-column-top-tag": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "height": "0.42667rem",
    "paddingLeft": "0.16rem",
    "paddingRight": "0.16rem",
    "borderRadius": "0 0 0.16rem 0",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "three-column-top-tag-text": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)"
  },
  "three-column-location-overlay": {
    "position": "absolute",
    "bottom": 0,
    "left": 0,
    "right": 0,
    "height": "0.53333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingLeft": "0.2rem",
    "paddingRight": "0.10667rem"
  },
  "three-column-location-icon-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginRight": "0.13333rem"
  },
  "three-column-location-text": {
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.53333rem",
    "flex": 1
  },
  "three-column-content": {
    "display": "flex",
    "flexDirection": "column",
    "paddingTop": "0.14667rem",
    "paddingRight": "0.16rem",
    "paddingBottom": "0.14667rem",
    "paddingLeft": "0.16rem"
  },
  "three-column-name": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "color": "rgb(17,17,17)",
    "lineHeight": "0.45333rem",
    "height": "0.90667rem",
    "marginBottom": "0.10667rem",
    "overflow": "hidden"
  },
  "three-column-tags": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginBottom": "0.21333rem"
  },
  "three-column-tag-item": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "borderRadius": "0.08rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,226,188)",
    "marginRight": "0.08rem"
  },
  "three-column-tag-item-text": {
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.37333rem"
  },
  "three-column-bottom": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "three-column-price-wrapper": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "maxWidth": "1.57333rem",
    "height": "0.8rem"
  },
  "three-column-price-symbol": {
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "fontSize": "0.32rem",
    "color": "rgb(255,65,0)"
  },
  "three-column-price": {
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "color": "rgb(255,65,0)"
  },
  "three-column-price-qi": {
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.29333rem",
    "color": "rgb(136,136,136)"
  },
  "three-column-original-price": {
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "color": "rgb(153,153,153)",
    "textDecoration": "line-through",
    "WebkitTextDecorationColor": "#999",
    "textDecorationColor": "#999",
    "marginTop": "-0.08rem"
  },
  "three-column-buy-button": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "1.12rem",
    "height": "0.64rem",
    "borderRadius": "0.64rem"
  },
  "three-column-buy-text": {
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.64rem"
  }
};



  module.exports = _styles;
  